var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.688 21.599l-6.086-10.235L16.517 1.14A2.362 2.362 0 0014.495 0c-.833 0-1.605.433-2.022 1.13L.313 21.58a2.22 2.22 0 000 2.27A2.338 2.338 0 002.333 25h24.332c.833 0 1.605-.442 2.022-1.14a2.202 2.202 0 000-2.261zM13.276 7.717c0-.629.518-1.13 1.168-1.13.65 0 1.168.501 1.168 1.13v7.767c0 .629-.518 1.13-1.168 1.13-.65 0-1.168-.501-1.168-1.13V7.717zm1.219 13.567c-.843 0-1.524-.659-1.524-1.475 0-.816.68-1.474 1.524-1.474.843 0 1.524.658 1.524 1.474s-.68 1.475-1.524 1.475z",
    fill: "#23B916"
  })));
}

export default SvgWarningGreen;